import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { Hero } from "@/components/sections/Hero";
import { EntryPaths } from "@/components/sections/EntryPaths";
import { Applications } from "@/components/sections/Applications";
import { Process } from "@/components/sections/Process";
import { Production } from "@/components/sections/Production";
import { Materials } from "@/components/sections/Materials";
import { Quality } from "@/components/sections/Quality";
import { Confidentiality } from "@/components/sections/Confidentiality";
import { RequestStatus } from "@/components/sections/RequestStatus";
import { QuotePreview } from "@/components/sections/QuotePreview";
import { Faq } from "@/components/sections/Faq";
import { FinalCta } from "@/components/sections/FinalCta";
import { ANALYTICS_EVENTS, trackEvent } from "@/api/analyticsApi";

export default function Home() {
  React.useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.HOMEPAGE_VIEW);
  }, []);

  return (
    <SiteLayout>
      <Hero />
      <EntryPaths />
      <Applications />
      <Process />
      <Production />
      <Materials />
      <Quality />
      <Confidentiality />
      <RequestStatus />
      <QuotePreview />
      <Faq />
      <FinalCta />
    </SiteLayout>
  );
}
